import { Directive } from '@angular/core';

@Directive({
    selector: '[pPageExtrasDef]',
})
export class PageExtrasDefDirective {}
